import { useState, useEffect } from 'react';
import {
  subscribeToActivityCount,
  subscribeToTotalCount,
  subscribeToConnection,
} from '../services/webSocketService';

// Hook to get activity count from WebSocket
export function useActivityCount(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    return subscribeToActivityCount(setCount);
  }, []);

  return count;
}

// Hook to get total count (activities + invitations)
export function useTotalCount(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    return subscribeToTotalCount(setCount);
  }, []);

  return count;
}

// Hook to get WebSocket connection status
export function useWebSocketConnection(): boolean {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    return subscribeToConnection(setConnected);
  }, []);

  return connected;
}
